import { render, staticRenderFns } from "./MobileCard.vue?vue&type=template&id=5016a9c3&scoped=true&"
import script from "./MobileCard.vue?vue&type=script&lang=js&"
export * from "./MobileCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileCard.vue?vue&type=style&index=0&id=5016a9c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016a9c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VRow})
